export default {
    data() {
        return {
            loading: false
        }
    },
    mounted() {
        this.loading = true
        this.$store.commit('setSystem', this.type);
        this.$store.dispatch('prepareMaterials', true)
            .then(() => {
                this.loading = false
            })
            .catch(() => {
                this.loading = false;
            });
        this.$store.dispatch('setActualCurrencies');
    },
    computed: {
        type() {
            return this.$route.meta.type;
        },
    }
}
